export const bodyScroll: { add: () => void; remove: () => void } = {
  add: () => {
    const body = document.querySelector('body')
    body?.classList.remove('removeScroll')
  },
  remove: () => {
    const body = document.querySelector('body')
    body?.classList.add('removeScroll')
  },
}
